var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "none",
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M266.7,132.2v176.4c0,9.4-7.6,17.2-17,17.1c-9.3-0.1-16.4-7.3-16.4-16.7V132.2c0-9.2,7.5-16.7,16.7-16.7h0 C259.2,115.5,266.7,123,266.7,132.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    cx: 250,
    cy: 367.8,
    r: 16.7
  })), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M250,494.8c-1.9,0-3.7-0.4-5.4-1.1C185.1,469.5,134.8,428.5,99,375.2S44.3,259.8,44.3,195.6V99 c0-5.8,3.5-11,8.8-13.2L244.5,6.3c1.8-0.7,3.6-1.1,5.5-1.1c1.9,0,3.7,0.4,5.5,1.1l191.4,79.5c5.4,2.2,8.8,7.4,8.8,13.2v96.6 c0,64.2-18.9,126.3-54.7,179.6c-35.8,53.3-86.1,94.3-145.6,118.5C253.7,494.4,251.9,494.8,250,494.8z M72.9,108.6v87 c0,116.2,68.7,221.6,175,268.4l2.1,0.9l2.1-0.9c106.3-46.8,175-152.2,175-268.4v-87L250,35L72.9,108.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.1e082f245df7c2970882f97532ac977f.svg";
export { ForwardRef as ReactComponent };